import {
    pxArrayToRem,
    pxToRem,
    flexClassName,
    SubheaderClassName,
    captionClassName,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import {
    TILE_HEIGHT_DESKTOP,
    TILE_WIDTH_DESKTOP,
    UPLOAD_TILE_HEIGHT_MOBILE,
    UPLOAD_TILE_WIDTH_MOBILE,
} from '../../config';

const ERROR_TILE_BG = '#F8F8F8'; // not in aria

export const ErrorMsgTile: StyleRule = ({ theme }) => ({
    width: pxToRem(UPLOAD_TILE_WIDTH_MOBILE),
    height: pxToRem(248),
    background: ERROR_TILE_BG,
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',

    [`& > .${flexClassName}`]: {
        padding: pxArrayToRem([101, 0, 28, 2]),

        [`& .${svgIconClassName}`]: {
            width: pxToRem(19),
            height: pxToRem(19),
            margin: pxArrayToRem([-2, 5, 0, 0]),
            '& svg path:last-child': {
                fill: theme.siteVariables.colors.danger[200],
            },
        },

        [`& .${SubheaderClassName}`]: {
            fontSize: pxToRem(16),
            color: theme.siteVariables.colors.danger[200],
            letterSpacing: theme.siteVariables.letterSpacingSmall,
            fontWeight: 500,
            paddingRight: pxToRem(9),
        },
    },

    [`& > .${captionClassName}`]: {
        fontSize: pxToRem(14),
        color: theme.siteVariables.colors.danger[200],
        letterSpacing: theme.siteVariables.letterSpacingNormal,
        padding: pxArrayToRem([0, 12]),
        textAlign: 'center',
        lineHeight: 1.2,
    },

    [theme.screen.tablet]: {
        width: pxToRem(TILE_WIDTH_DESKTOP),
        height: pxToRem(TILE_HEIGHT_DESKTOP),

        [`& > .${flexClassName}`]: {
            padding: pxArrayToRem([98, 0, 32, 6]),
        },

        [`& > .${captionClassName}`]: {
            lineHeight: 1,
        },
    },
});

export const DragDropErrorMsg: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([10, 0, 11, 0]),
    [`& .${svgIconClassName}`]: {
        width: pxToRem(18),
        height: pxToRem(18),
        margin: pxArrayToRem([0, 4, 0, 0]),
        '& svg path:last-child': {
            fill: theme.siteVariables.colors.danger[200],
        },
    },

    [`& .${SubheaderClassName}`]: {
        fontSize: pxToRem(16),
        color: theme.siteVariables.colors.danger[200],
        letterSpacing: theme.siteVariables.letterSpacingSmall,
        fontWeight: 500,
        paddingRight: pxToRem(8),
    },

    [`& .${captionClassName}`]: {
        fontSize: pxToRem(16),
        color: theme.siteVariables.colors.danger[200],
        letterSpacing: theme.siteVariables.letterSpacingSmall,
    },
});

export const LoadingTileLoader: StyleRule = ({ theme }) => ({
    width: pxToRem(UPLOAD_TILE_WIDTH_MOBILE),
    height: pxToRem(UPLOAD_TILE_HEIGHT_MOBILE),
    background: ERROR_TILE_BG,
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',

    [`& .${svgIconClassName}`]: {
        width: pxToRem(32),
        height: pxToRem(32),
        margin: pxArrayToRem([2, 0, 0, 8]),
    },

    [theme.screen.tablet]: {
        width: pxToRem(TILE_WIDTH_DESKTOP),
        height: pxToRem(TILE_HEIGHT_DESKTOP),

        [`& .${svgIconClassName}`]: {
            width: pxToRem(24),
            height: pxToRem(24),
            margin: 0,
        },
    },
});

export const LoadingTileText: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([18, 0, 0, 12]),

    [theme.screen.tablet]: {
        display: 'none',
    },
});
